export * from './NewsFeedIcon';
export * from './NewsFeedIcon16Light';
export * from './NewsFeedIcon16Regular';
export * from './NewsFeedIcon16Solid';
export * from './NewsFeedIcon20Light';
export * from './NewsFeedIcon20Regular';
export * from './NewsFeedIcon20Solid';
export * from './NewsFeedIcon24Regular';
export * from './NewsFeedIcon24Solid';
export * from './NewsFeedIcon32Regular';
export * from './NewsFeedIcon64Regular';
